import { render, staticRenderFns } from "./EntityModal.vue?vue&type=template&id=f8b1d2b0&"
import script from "./EntityModal.vue?vue&type=script&lang=ts&"
export * from "./EntityModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports